import { Component } from '@angular/core';
import {MatTab, MatTabGroup} from '@angular/material/tabs';
import {OrganizationsComponent} from './organizations/organizations.component';
import {RecurringEventsComponent} from './recurring-events/recurring-events.component';
import {AdminUsersComponent} from './users/admin-users.component';

@Component({
  selector: 'app-admin',
  imports: [
    MatTabGroup,
    MatTab,
    OrganizationsComponent,
    RecurringEventsComponent,
    AdminUsersComponent
  ],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss'
})
export class AdminComponent {

}
